import {sendRequest, serializeObject} from '@js/utils';

export function lazyloadRows(pageParam, $showSliceBtn, mode, rankingId = 0) {
    const $rankingResultsContainer = $('.ranking-results');
    const offset = parseInt($rankingResultsContainer.attr('data-offset'), 10);
    const queryParams = `${pageParam}&${serializeObject({offset})}`;
    return new Promise((resolve) => {
        $showSliceBtn.text('Загрузка ...')
            .addClass('loading-cursor')
            .prop('disabled', true);
        sendRequest('get', `/ratings/getRankingSlice?${queryParams}`, {}, (res) => {
            const success = typeof res !== 'undefined' && res.hasOwnProperty('success') && res.success;
            if (success && res?.data?.html) {
                const scrollPosition = $(window)
                    .scrollTop();
                const isLastSlice = res.data.is_last_slice;
                switch (mode) {
                    case 'table':
                        //временная штука, после полного редизайна будет удалена за ненадобностью
                        if ([31, 29, 50].includes(parseInt(rankingId))) {
                            $('.ranking-results .ranking-tiles').append(res.data.html);
                        } else {
                            $('.ranking-results .ranking-table').find('tbody').append(res.data.html);
                        }
                        break;
                    case 'card':
                        $('.ranking-results-cards').append(res.data.html);
                        break;
                    default:
                        break;
                }
                $(window).scrollTop(scrollPosition);
                if (isLastSlice) {
                    $showSliceBtn.closest('.show-next-slice-ranking-container').remove();
                } else {
                    $showSliceBtn.text('Показать ещё').removeClass('loading-cursor').prop('disabled', false);
                }
                $rankingResultsContainer.attr('data-offset', res.data.offset);
                resolve();
            } else {
                $showSliceBtn.text('Произошла ошибка');
            }
        });
    });
}
